import { HttpError } from './HttpError';
import { InvalidSessionError } from './InvalidSessionError';
import { ReportService } from '../services/ReportService';
import { Router } from '../router/Router';
import { ApiService } from '../services/ApiService';

/**
 * AppError.
 */
export class AppError {
  /**
   * String of the dom element of the default error.
   *
   * @type {string}
   */
  static defaultErrorSelector = '#technicalError';

  /**
   * Display error according to its type.
   * (and report an error in the default case).
   *
   * @param {*} err - Error to display to the user.
   */
  static showError(err) {
    const token = ApiService.invitationId;
    switch (true) {
      case err instanceof InvalidSessionError:
        Router.insertExpire();
        break;
      case err instanceof HttpError:
        if (!(typeof token !== 'undefined' && ApiService.shouldSkipConfirm()) && err.status !== 302 && err.status !== 205) {
          Router.insertTechnicalError();
        }
        break;
      default:
        if (!err || (err && err.status !== 302 && err.status !== 205)) {
          AppError.showDefault();
        }
        if (Eui.reportError) {
          ReportService.sendError(err);
        }
    }
  }

  /**
   * Display the default error.
   */
  static showDefault() {
    const defaultErrorNode = document.querySelector(AppError.defaultErrorSelector);

    if (defaultErrorNode && defaultErrorNode.className.indexOf('hidden') !== -1) {
      defaultErrorNode.className = '';
    }
  }

  /**
   * Hide the default error.
   */
  static hideDefault() {
    const defaultErrorNode = document.querySelector(AppError.defaultErrorSelector);

    if (defaultErrorNode && defaultErrorNode.className.indexOf('hidden') === -1) {
      defaultErrorNode.className = 'hidden';
    }
  }
}
